import { TextAlign } from '@tiptap/extension-text-align';
import { Gif } from '../extension-gif/gif';
import { DaGallery } from '../extension-gallery/gallery';
import { DaDeviation } from '../extension-deviation/deviation';
import { areAnyNodesOfTypesNearby } from './utils';
import { DaVideo } from '../extension-video/daVideo';
const invalidExtensions = [
    Gif.name,
    DaGallery.name,
    DaDeviation.name,
    DaVideo.name
];
export const DaTextAlign = TextAlign.extend({
    name: 'da-text-align',
    // Same as parent just added element.getAttribute('align') to support libreoffice pastes
    addGlobalAttributes () {
        return [
            {
                types: this.options.types,
                attributes: {
                    textAlign: {
                        default: this.options.defaultAlignment,
                        parseHTML: (element)=>{
                            const alignment = element.style.textAlign || element.getAttribute('align') || this.options.defaultAlignment;
                            return this.options.alignments.includes(alignment) ? alignment : this.options.defaultAlignment;
                        },
                        renderHTML: (attributes)=>{
                            if (attributes.textAlign === this.options.defaultAlignment) {
                                return {};
                            }
                            return {
                                style: `text-align: ${attributes.textAlign}`
                            };
                        }
                    }
                }
            }
        ];
    },
    addCommands () {
        var _this_parent, _this;
        const parentCommands = (_this_parent = (_this = this).parent) === null || _this_parent === void 0 ? void 0 : _this_parent.call(_this);
        return {
            unsetTextAlign: parentCommands === null || parentCommands === void 0 ? void 0 : parentCommands.unsetTextAlign,
            setTextAlign: (alignment)=>(object)=>{
                    if (areAnyNodesOfTypesNearby(this.editor.state, invalidExtensions) || !parentCommands || !parentCommands.setTextAlign) {
                        return false;
                    }
                    return parentCommands.setTextAlign(alignment)(object);
                }
        };
    }
});

//# sourceMappingURL=alignment.js.map